export default __webpack_public_path__ + "static/media/active_call.e1a161ad.svg";